import { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { observer } from 'mobx-react'
//@ts-ignore
import styled, { useTheme } from 'styled-components'
import { BackendUser, OnboardingQuestion, Questions } from 'common/types'
import { Button } from 'common/atoms/Button/Button'
import { StyledContainer, StyledSelect } from 'pages/profile/styled'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { industries, expertise, experience, yearsOfExperience } from 'common/select-options'
import { InputFieldGroup } from 'common/molecules/InputFieldGroup/InputFieldGroup'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { careerSummaryState } from 'models/account-settings/career-summary.store'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import validator from 'validator'


const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        width: '100%',
        height: `${props => (props.isDevice ? 'auto' : '709px')}`,
        flexShrink: 0
    },
}))

const CareerSummary = () => {
    const {backendUser} = useAuth()
    const theme = useTheme()
    const classes = useStyles()
    const { isDevice } = useScreenSizes()
    const { buttonEnabled, setButtonEnabled } = careerSummaryState
    const { completeEditOnboarding } = useOnboarding()
    const [isValidUrl, setIsValidUrl] = useState(true)

    const [ questions, setQuestions ] = useState(backendUser?.onboardingQuestions)

    const findAnswer = (question) => {
        const answer = questions.find(ans => ans.question.trim() === question)
        return answer?.answer
    }

    function handleChange(question, newValue) {
        setQuestions((prevData) => {
            const updatedData = prevData.map((item) => {
              if (item.question === question) {
                return { ...item, answer: newValue }
              } else {
                return item
              }
            })
            return updatedData
          })
          if (question === 'Website') {
            const isValid = newValue.trim() === '' || validateWebsite(newValue)
            setIsValidUrl(isValid)
        }
    }

    const validateWebsite = (url) => {
        return validator.isURL(url)
    }
    

    useEffect(() => {
        const foundDiff = questions.some((questionAnswer) => {
            const foundQuestion = backendUser?.onboardingQuestions.find(q => q.question === questionAnswer.question)
            return questionAnswer.answer !== foundQuestion?.answer
        })
        if(foundDiff){
            setButtonEnabled(true)
        } else {
            setButtonEnabled(false)
        }
    }, [questions])

    return (
        <StyledContainer width="100%" zIndex={0} className={classes.root} isDevice={isDevice}>
            <Box width='100%' display='grid' gridRowGap='1rem'>
                <Box>
                    <InputFieldGroup
                        label='Headline'
                        placeholder='Enter Headline'
                        key={Questions.HEADLINE.toString()}
                        name={Questions.HEADLINE.toString()}
                        value={findAnswer('Headline')}
                        onChange={(e) => { 
                            const newValue = e.target.value;
                            handleChange('Headline', newValue);
                         }}
                    />
                </Box>
                <Box display='grid' gridTemplateColumns={isDevice ? "1fr": "1fr 1fr 1fr"} gridTemplateRows='1fr' width='100%' gridGap='0.75em'>
                    <Box width='100%'>
                        <InputFieldGroup
                            label='Company Name'
                            placeholder='Enter Company Name'
                            value={findAnswer('Company Name')}
                            key={Questions.COMPANY_NAME.toString()}
                            name={Questions.COMPANY_NAME.toString()}
                            onChange={(e) => { 
                                const newValue = e.target.value;
                                handleChange('Company Name', newValue);
                             }}
                        />
                    </Box>
                    <Box width='100%'>
                        <StyledSelect
                            label='Experience Level'
                            menuItemList={experience}
                            theme={theme}
                            width='100%'
                            placeholder='Select Option'
                            autoWidth={false}
                            multiple={false}
                            native={false}
                            name={Questions.EXPERIENCE_LEVEL.toString()}
                            key={Questions.EXPERIENCE_LEVEL.toString()}
                            value={findAnswer('Experience Level')}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                handleChange('Experience Level', newValue);
                            }}
                        />
                    </Box>
                    <Box width='100%'>
                        <StyledSelect
                            label='Years of experience'
                            menuItemList={yearsOfExperience}
                            theme={theme}
                            width='100%'
                            placeholder='Select Option'
                            autoWidth={false}
                            multiple={false}
                            native={false}
                            value={findAnswer("Years of experience")}
                            key={Questions.YEARS_OF_EXPERIENCE.toString()}
                            name={Questions.YEARS_OF_EXPERIENCE.toString()}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                handleChange("Years of experience", newValue);
                            }}
                        />
                    </Box>
                </Box>
                <Box display='grid' gridTemplateColumns={isDevice ? "1fr": "1fr 1fr"} gridTemplateRows='1fr' width='100%' gridGap='0.75em'>
                    <Box width='100%'>
                        <StyledSelect
                            label='Industry'
                            menuItemList={industries}
                            theme={theme}
                            width='100%'
                            placeholder='Select Option'
                            autoWidth={false}
                            multiple={false}
                            native={false}
                            value={findAnswer('Industry')}
                            name={Questions.INDUSTRY.toString()}
                            key={Questions.INDUSTRY.toString()}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                handleChange('Industry', newValue);
                            }}
                        />
                    </Box>
                    <Box width='100%'>
                        <StyledSelect
                            label='Area of Expertise'
                            menuItemList={expertise}
                            theme={theme}
                            width='100%'
                            placeholder='Select Option'
                            autoWidth={false}
                            multiple={false}
                            native={false}
                            value={findAnswer('Area of Expertise')}
                            name={Questions.AREA_OF_EXPERTISE.toString()}
                            key={Questions.AREA_OF_EXPERTISE.toString()}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                handleChange('Area of Expertise', newValue);
                            }}
                        />
                    </Box>
                </Box>
                <Box>
                    <InputFieldGroup
                        label='Website'
                        placeholder='Enter Website'
                        value={findAnswer('Website')}
                        name={Questions.WEBSITE.toString()}
                        key={Questions.WEBSITE.toString()}
                        onChange={(e) => {
                            const newValue = e.target.value
                            handleChange('Website', newValue)
                        }}
                        error={!isValidUrl }
                        helperText={isValidUrl ? '' : 'Invalid URL'}
                    />
                </Box>
                {isDevice && <Box display='flex' justifyContent='end'>
                    <Button
                        design='primary'
                        onClick={async() => { 
                            completeEditOnboarding(questions, true)
                            setButtonEnabled(false)
                        }}
                        disabled={!buttonEnabled ||
                            (findAnswer('Website').trim() !== '' && !isValidUrl)}
                    >
                        Update
                    </Button>
                </Box>}
            </Box>
        </StyledContainer>
    )
}

export default observer(CareerSummary)